import React from 'react';
import { track as trackEvent } from '../analytics';

// Apple's "Download on the App Store" badge — inline SVG so we don't ship
// a binary asset. Proportions and font sizes follow Apple's marketing
// guidelines: small "Download on the" caption above larger "App Store".
function AppStoreBadge({ href, className = '', surface = 'app_store_badge', onClick, ...rest }) {
    const handleClick = (e) => {
        trackEvent('install_cta_clicked', { surface });
        if (onClick) onClick(e);
    };
    return (
        <a
            href={href}
            className={`app-store-badge ${className}`}
            aria-label="Download on the App Store"
            onClick={handleClick}
            {...rest}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 135 40"
                role="img"
                aria-hidden="true"
            >
                <rect
                    width="134"
                    height="39"
                    x="0.5"
                    y="0.5"
                    rx="6"
                    fill="#000"
                    stroke="rgba(255,255,255,0.35)"
                />
                <path
                    fill="#fff"
                    transform="translate(13, 8) scale(1.0)"
                    d="M17.05 16.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 11.25 3.51 3.59 9.05 3.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12 3.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"
                />
                <text
                    x="40"
                    y="17"
                    fill="#fff"
                    fontFamily="-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Helvetica Neue', sans-serif"
                    fontSize="8"
                    letterSpacing="0.2"
                >
                    Download on the
                </text>
                <text
                    x="40"
                    y="31"
                    fill="#fff"
                    fontFamily="-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Helvetica Neue', sans-serif"
                    fontSize="17"
                    fontWeight="500"
                    letterSpacing="-0.3"
                >
                    App Store
                </text>
            </svg>
        </a>
    );
}

export default AppStoreBadge;
